import { render, staticRenderFns } from "./DetalhesPedido.vue?vue&type=template&id=ceef6d32&scoped=true&"
import script from "./DetalhesPedido.vue?vue&type=script&lang=js&"
export * from "./DetalhesPedido.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesPedido.vue?vue&type=style&index=0&id=ceef6d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceef6d32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
